function AddChat({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 2.5C15.91 2.5 19.5 6.09 19.5 10.5C19.5 14.91 15.91 18.5 11.5 18.5C10.32 18.5 9.16 18.24 8.07 17.72C7.8 17.59 7.51 17.53 7.21 17.53C7.02 17.53 6.83 17.56 6.65 17.61L3.45 18.55L4.39 15.35C4.53 14.88 4.49 14.37 4.28 13.93C3.76 12.84 3.5 11.68 3.5 10.5C3.5 6.09 7.09 2.5 11.5 2.5ZM11.5 0.5C5.98 0.5 1.5 4.98 1.5 10.5C1.5 12.04 1.86 13.48 2.47 14.79L0.5 21.5L7.21 19.53C8.52 20.14 9.96 20.5 11.5 20.5C17.02 20.5 21.5 16.02 21.5 10.5C21.5 4.98 17.02 0.5 11.5 0.5Z" fill=${`"${col}"`}/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 6.5H10.5V9.5H7.5V11.5H10.5V14.5H12.5V11.5H15.5V9.5H12.5V6.5Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default AddChat;
